module.exports = __webpack_public_path__ + "static/media/view2.ae5a2492.jpg";